<script>  
  import { fade } from "svelte/transition";
    import Navigationbar from "../components/Navigationbar.svelte";
    import News from "../components/News.svelte";
    import Title from "../components/Title.svelte"; 
    window.scroll({
  top: 0, 
  left: 0, 
  behavior: 'smooth'
});
import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });
  


//scroll to top every page load
window.scroll({
  top: 0,
  left: 0,
  behavior: "smooth",
});

//navigation
let navigation = [];
   $: if (settings.loggedin == true) {
    if(settings.data.pen!=undefined){
    navigation["message"] = settings.data.pen.nm;
    }else {
      
    navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

//alert
let alert = []; 
</script>
<svelte:head>
<title>Kabar Ke Dekatan</title>
</svelte:head>
<Navigationbar backbtn="true" message={navigation['message']}  title="Kabar"/>
<main transition:fade class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0">
 
<div  class="max-w-6xl pt-2 mx-auto my-5">
  <Title subtitle="" title="Berita Terkini" />
</div>
<div class="flex flex-wrap items-center max-w-6xl mx-auto my-5 lg:my-0 ">
  
    
<News load="10" />
    
</div>
</main>